export default __webpack_public_path__ + "i18n/translations/translation-id.a183c95b.json";